import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ButtonIconPosition, ButtonStretch, ButtonVariant } from '../button-types';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @Input({ required: true }) label!: string;
  @Input() icon?: string;
  @Input() iconPosition?: ButtonIconPosition;
  @Input() disabled = false;
  @Input() loading = false;
  @Input() stretch: ButtonStretch = 'hug';
  @Input() variant: ButtonVariant = 'primary';
  @Output() clickEvent = new EventEmitter<void>();

  get labelStyles(): [string, string][] {
    const prefix = `button-action-${this.variant}`;
    return [
      ['type', `${prefix}-label`],
      ['text-color', `${prefix}-label`],
    ];
  }

  get buttonStyles(): [string, string][] {
    return [
      ['border-radius', `button-action-${this.variant}`],
      ['height', `button-action-${this.variant}`],
    ];
  }

  get iconStyles(): [string, string][] {
    return [['text-color', `button-action-${this.variant}-icon`]];
  }

  get spinnerStyles(): [string, string][] {
    return [['text-color', `button-action-${this.variant}-icon`]];
  }

  onClick(): void {
    if (!this.disabled) {
      this.clickEvent.emit();
    }
  }
}
